export default {"src":"/flights/assets/desktop/_next/static/media/kaaba.79c710e4.svg","height":24,"width":24};